export default "__VITE_ASSET__DIe1_ygK__"